<div class="flex flex-column">
  <div class="flex items-center mt1">
    <span><b>Conditions</b></span>
    <mat-icon *ngIf="hasPermissions"
              class="add-icon"
              color="primary"
              matTooltip="Add condition"
              (click)="onAddCondition()">add
    </mat-icon>
  </div>
</div>

<div *ngIf="conditions && conditions.length > 0">
  <p>Note: the condition specific waiting period for each these conditions, if applicable, is shown above</p>
  <ul>
    <li *ngFor="let condition of conditions" class="flex items-center">
      <span>{{getConditionString(condition)}}</span>
      
      <ng-container *ngIf="hasPermissions">
        <mat-icon class="edit-icon"
                  color="primary"
                  matTooltip="Edit condition"
                  (click)="onEditCondition(condition)">edit
        </mat-icon>
        
        <mat-icon class="edit-icon"
                  color="primary"
                  matTooltip="Delete condition"
                  (click)="onDeleteCondition(condition)">delete
        </mat-icon>
      </ng-container>
    </li>
  </ul>
</div>

<div *ngIf="!conditions || conditions.length === 0">
  <p>No conditions found.</p>
</div>
